import { makeAutoObservable, reaction } from "mobx";
import { ServerError } from "../models/ServerError";

export default class CommonStore {
    error: ServerError | null = null;
    token: string | null = localStorage.getItem('govedia-base-jwt');
    appLoaded = false;

    constructor() {
        makeAutoObservable(this);

        // this reaction only runs when token changes
        // this will make the token persist on page refresh/redirects
        reaction(
            () => this.token, 
            token => {
                if (token)
                {
                    localStorage.setItem('govedia-base-jwt', token);
                } 
                else 
                {
                    localStorage.removeItem('govedia-base-jwt');
                }
            }
        )
    }
    
    setServerError(error: ServerError) {
        this.error = error;
    }

    setToken = (token : string | null) => {
        this.token = token;
    }

    setAppLoaded = () => {
        this.appLoaded = true;
    }
   
}